import Matrix from 'ml-matrix';
import simpleClustering from 'ml-simple-clustering';
export function ensureSpinSystemProps(spinSystem) {
    const { couplingConstants } = spinSystem;
    const { clusters, levels = new Array(couplingConstants.rows).fill(2), connectivity = connectivityMatrixFromCouplingMatrix(couplingConstants), } = spinSystem;
    return {
        levels,
        clusters: clusters ||
            simpleClustering(connectivity.to2DArray(), {
                out: 'indexes',
            }),
        connectivity,
        ...spinSystem,
    };
}
function connectivityMatrixFromCouplingMatrix(couplingConstants) {
    const connectivity = Matrix.ones(couplingConstants.rows, couplingConstants.rows);
    for (let i = 0; i < couplingConstants.rows; i++) {
        for (let j = i; j < couplingConstants.columns; j++) {
            if (couplingConstants.get(i, j) === 0) {
                connectivity.set(i, j, 0);
                connectivity.set(j, i, 0);
            }
        }
    }
    return connectivity;
}
//# sourceMappingURL=ensureSpinSystemProps.js.map